import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import Logo from '../../images/CharityChoiceLogo-Flat-Comp.svg';
import {
  Row,
  Col,
  FormGroup,
  Input,
  InputGroup,
  Button,
  Container,
  NavbarBrand,
} from 'reactstrap';
import { redeemCodeValidation } from '../../Code/Utilities';

export default function Header(props) {
  return (
    <Switch>
      <Route exact path="/GCE" render={() => <WithoutRedeem {...props} />} />
      <Route render={() => <WithRedeem {...props} />} />
    </Switch>
  );
}

class WithRedeem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redeemCode: '',
      submitted: false,
    };
  }

  handleChangeRedeemCode = ({ target }) => {
    redeemCodeValidation(target.value) &&
      this.setState({ redeemCode: target.value });
  };

  redeem = () => {
    this.setState({ submitted: true });

    if (!this.state.redeemCode) {
      return;
    }
    window.location = `/Redeem/?RC=${this.state.redeemCode}`;
  };

  giveNow = () => {
    this.props.history.push('/#GiveGiftCards');
  };
  render() {
    const { redeemCode, submitted } = this.state;
    return (
      <section>
        <Container>
          <Row className="row header-row justify-content-center align-items-center">
            <Col xs="12" sm="10" md="8" lg="4" className="text-center">
              <NavbarBrand href="/">
                <img src={Logo} alt="CharityChoice Logo" longdesc="Tax deductible Donation Gift Cards. The best charity gift; a meaningful, thoughtful way of 'giving back'. Choose from causes who help with animal protection and shelters, environment, homeless, education, food banks, children, disease, research and health, disaster relief � floods, tornados, tsunamis, hurricanes, earthquakes." />
              </NavbarBrand>
            </Col>
            <Col xs="12" md="6" lg="4" className="text-center">
              <div className="form-inline justify-content-center d-none d-md-block  pt-4">
                <FormGroup className="justify-content-center">
                  <InputGroup className="header-redemption-form input-group-transparent">
                    <Input
                      type="text"
                      placeholder="Enter Card Code"
                      className="form-control  form-control-sm redeem-code"
                      invalid={submitted && !redeemCode}
                      value={redeemCode}
                      onKeyPress={event =>
                        event.key === 'Enter' && this.redeem()
                      }
                      onChange={this.handleChangeRedeemCode}
                    />
                  </InputGroup>
                  <InputGroup className="header-redemption-button input-group-transparent">
                    <Button color="primary" onClick={this.redeem} size="sm">
                      Redeem
                    </Button>
                  </InputGroup>
                </FormGroup>
                <div>
                  <a className="very-small" href="/Redeem/MultipleRedemption.aspx">Redeem Multiple Codes</a>
                </div>
              </div>
              <div className="form-inline justify-content-center d-md-none">
                <FormGroup className="header-form-group justify-content-center">
                  <Row>
                    <Col xs={7} className="pr-0">
                      <InputGroup className="header-redemption-form input-group-transparent">
                        <Input
                          type="text"
                          placeholder="Enter Card Code"
                          className="form-control form-control-sm redeem-code"
                          invalid={submitted && !redeemCode}
                          value={redeemCode}
                          onKeyPress={event =>
                            event.key === 'Enter' && this.redeem()
                          }
                          onChange={this.handleChangeRedeemCode}
                        />
                      </InputGroup>
                    </Col>
                    <Col xs={5} className="pl-1">
                      <InputGroup className="header-redemption-button input-group-transparent">
                        <Button
                          color="primary"
                          block
                          onClick={this.redeem}
                          className="px-1"
                          size="sm">
                          Redeem
                        </Button>
                      </InputGroup>
                    </Col>
                  </Row>
                </FormGroup>
              </div>
            </Col>
            {this.props.showFreeHolidayShipping &&
              <Col
                xs="12"
                md="2"
                className="text-center justify-content-center small text-uppercase">
                <strong style={{ color: '#c44042' }}>
                  FREE PRIORITY SHIPPING
              </strong>
              </Col>
            }
            <Col
              xs="12"
              md="4"
              lg="2"
              className="buy-now-button text-center justify-content-center">
              <Button
                color="primary"
                className="d-none d-md-block"
                onClick={this.giveNow}>
                Give a Card Now!
              </Button>
              <Button
                color="primary"
                block
                className="d-md-none"
                onClick={this.giveNow}>
                Give a Card Now!
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}

function WithoutRedeem(props) {
  return (
    <section>
      <Container>
        <Row className="row header-row justify-content-center align-items-center">
          <Col xs="12" sm="10" md="8" lg="4" className="text-center">
            <NavbarBrand href="/">
              <img src={Logo} alt="CharityChoice Logo. Giving back instead of a Holiday gift during COVID 19." />
            </NavbarBrand>
          </Col>
          <Col
            xs="12"
            md="3"
            lg="2"
            className="buy-now-button text-center justify-content-center">
            <Link to="/Purchase">
              <Button color="primary" className="d-none d-md-block">
                Give Now!
              </Button>
            </Link>
            <Link to="/Purchase">
              <Button color="primary" block className="d-md-none">
                Give Now!
              </Button>
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
